import { objectToCamel } from './lib/object-to-camel.js';
import { Multiaddr } from 'multiaddr';
import { configure } from './lib/configure.js';
import { toUrlSearchParams } from './lib/to-url-search-params.js';
export const createId = configure(api => {
  async function id(options = {}) {
    const res = await api.post('id', {
      signal: options.signal,
      searchParams: toUrlSearchParams({
        arg: options.peerId ? options.peerId.toString() : undefined,
        ...options
      }),
      headers: options.headers
    });
    const data = await res.json();
    const output = { ...objectToCamel(data) };
    if (output.addresses) {
      output.addresses = output.addresses.map(ma => new Multiaddr(ma));
    }
    return output;
  }
  return id;
});